module.exports = __webpack_public_path__ + "img/Button_pengajuan.bf1c4745.svg";